import { Chip, type ChipProps } from '@jotpsych/ui';

import type { IntakeItemStatus, PayerProductStatus } from '../types';

type Status = IntakeItemStatus | PayerProductStatus;

const STATUS_CONFIG: Record<Status, { label: string; color: ChipProps['color'] }> = {
  missing: { label: 'Missing', color: 'default' },
  submitted: { label: 'Submitted', color: 'primary' },
  ai_flagged: { label: 'AI flagged', color: 'warning' },
  in_review: { label: 'In review', color: 'info' },
  accepted: { label: 'Accepted', color: 'success' },
  expiring: { label: 'Expiring', color: 'warning' },
  needs_attention: { label: 'Needs attention', color: 'error' },
  staff_in_progress: { label: 'JotPsych', color: 'primary' },
  staff_complete: { label: 'Complete', color: 'success' },
  not_applicable: { label: 'Not applicable', color: 'default' },
  not_started: { label: 'Not started', color: 'default' },
  needs_info: { label: 'Needs info', color: 'warning' },
  in_progress: { label: 'In progress', color: 'warning' },
  approved: { label: 'Approved', color: 'success' },
  active: { label: 'Active', color: 'success' },
};

interface IntakeStatusChipProps {
  status: Status;
  label?: string;
  size?: ChipProps['size'] | 'xSmall';
}

export function IntakeStatusChip({ status, label, size = 'xSmall' }: IntakeStatusChipProps) {
  const config = STATUS_CONFIG[status];

  return (
    <Chip
      label={label ?? config.label}
      color={config.color}
      size={size}
      variant="soft"
      sx={{ fontWeight: 700 }}
    />
  );
}
